import { apiEmpleo } from "../../util/ApiEmpleo";
import {
  OccupiedBlock,
  Schedule,
} from "../../apps/jobsite/components/WeeklyCalendar";

export type TEmployeeOccupiedScheduleItem = {
  contractId: string;
  contractName: string | null;
  clientName: string | null;
  estado: string | null;
  contractType: string | null;
  startDate: string | null;
  endDate: string | null;
  schedule: Schedule;
};

export type TGetEmployeeOccupiedSchedule = {
  occupiedSchedule: TEmployeeOccupiedScheduleItem[];
};

const apiGetEmployeeOccupiedSchedule = async (candidateId: string) => {
  const res: TGetEmployeeOccupiedSchedule = await apiEmpleo.get(
    `candidatos/${candidateId}/occupied-schedule`
  );

  return res;
};

// Adapta la ocupación de la API a los bloques de solo lectura de WeeklyCalendar.
const toOccupiedBlocks = (
  items: TEmployeeOccupiedScheduleItem[]
): OccupiedBlock[] =>
  items.map((item) => ({
    id: item.contractId,
    contractName: item.contractName,
    clientName: item.clientName,
    schedule: item.schedule,
  }));

export { apiGetEmployeeOccupiedSchedule, toOccupiedBlocks };
